var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.494 12.5185C15.4732 10.2603 17.3905 9.16171 17.4781 9.11057C16.3923 7.56704 14.7093 7.35615 14.1179 7.33933C12.7044 7.1943 11.3333 8.164 10.6132 8.164C9.87882 8.164 8.77 7.35335 7.57495 7.37717C6.03712 7.40029 4.59846 8.26839 3.80943 9.61643C2.18105 12.3651 3.39551 16.4043 4.95561 18.626C5.73602 19.7141 6.64794 20.9291 7.84155 20.8863C9.0093 20.8394 9.44549 20.1605 10.8547 20.1605C12.251 20.1605 12.6606 20.8863 13.8779 20.859C15.1311 20.8394 15.9202 19.766 16.6733 18.6681C17.5751 17.4209 17.9373 16.1927 17.9517 16.1296C17.9222 16.1198 15.5178 15.2251 15.494 12.5185Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1945 5.87779C13.8226 5.11198 14.2523 4.07012 14.133 3.01285C13.224 3.05208 12.0871 3.62591 11.4325 4.3749C10.8533 5.03491 10.3359 6.11671 10.4695 7.13405C11.4907 7.20831 12.5391 6.63168 13.1945 5.87779Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleWhite);
export default __webpack_public_path__ + "static/media/apple-white.591cd79646d94f4f1b1d8342f9435e90.svg";
export { ForwardRef as ReactComponent };